import { removeNodesFromTree } from '../../../components/Tree/helpers/helpers';
import { selectTreeDataByTreeId } from '../../selectors/tree/tree';
import { selectedTreeNodeSelector } from '../../selectors/tree/node';
import { resetSelectedNode } from '../../slices/treeSelection';
import { updateData } from '../../slices/tree';

export const removeNodes = (tree, paths) => async (dispatch, getState) => {
  const currentTreeData = selectTreeDataByTreeId(getState(), tree);
  const newTree = removeNodesFromTree({ paths, treeData: currentTreeData });
  await dispatch(updateData(tree, newTree.treeData));
  const { nodeItem } = selectedTreeNodeSelector(getState());
  if (nodeItem && paths.includes(nodeItem.path)) {
    await dispatch(resetSelectedNode());
  }
};

export const removeNode = (tree, path) => removeNodes(tree, [path]);
